export default {
	'userCancel': 'User cancellation',
	'addrLp': 'LP Contract Address',
	'bscInLbb': 'Cross',
	'goSwap': 'CSwap trading',
	'sumLbb': 'Accumulated {0} OC',
	'lookLbb': 'View contract',
	'addrLbb': 'OC contract address',
	'addrLock': 'Lock Contract Address',
	'lockedBalance': 'My Locked Balance',
	'ocLockTitle': 'OC Lock',
	'ocLockDeposit': 'Deposit',
	'ocLockActive': 'Status',
	'ocLockReleased': 'Released',
	'ocLockClaim': 'Claim',
	'lockTotal': 'Total',
	'lockDays': 'Remaining / Locked Days',
	'lockClaimable': 'Claimable',
	'lockClaimed': 'Claimed',
	'addrDead': 'Black hole address',
	'addrMarket': 'Marketing Address',
	'ratioTotal': 'Selling total slippage: 10%',
	'ratioLp': 'a. Liquidity coefficient: 5%',
	'ratioDead': 'b. Destruction coefficient: 3%',
	'ratioInv': 'c. Invitation coefficient: 1%',
	'ratioMarket': 'd. Marketing coefficient: 1%',
	'contractDesc': 'Logical full chain implementation',
	'contract': 'contract',
	'inviteTotal': 'Online invitation reward: {0} OC',
	'inviteMy': 'My invitation reward: {0} OC',
	'lpTotal': 'Global liquidity reward: {0} OC',
	'lpMy': 'My liquidity reward: {0} OC',
	'lpDesc': 'My/Global Liquidity: {0}/{1} LCC',
	'lpAdd': 'Add liquidity',
	'lp': 'liquidity',
	'invSell': 'Up to 1% invitation reward',
	'lpSell': 'Holding a liquidity weighted reward of 5% per sale',
	'myInvites': 'my invitation',
	'effective': 'effective',
	'ineffective': 'ineffective',
	'myInviter': 'My recommender',
	'invite': 'invitation',
	'inviteNotice1': 'Send 0.1 OC to the other party',
	'inviteNotice2': 'Once confirmed by the other party, the invitation is considered successful',
	'inviteBind': 'Please bind your recommender',
	'chainConfirm': 'On chain···',
	'{0} Operate Fast': '{0} operation is too frequent, please continue in {1} seconds',
	'English': 'English',
	'Chinese': '中文',
	'Conrim': 'confirm',
	'Osnft Detail': 'View details',
	'{0} Not Enogugh': 'Your {0} is insufficient',
	'Operate Success': 'Operation successful',
	'zlang143': 'Copy successful',
	'Cht': '繁體中文',
	'YueNan': 'Việt Nam',
	'YinNi': 'Bahasa Indonesia',
	'RiWen': ' にほんご',
	'HanWen': '한국어',
	'TaiWen': 'ไทย',
	'ALaBoWen': ' العربية ',
	'Balance Query': 'Balance Query',
	'Input Address': 'Input Address',
	'Query': 'Query',
	'Query Result': 'Query Result',
	'No Deposits': 'No Deposits',
	'Refresh': 'Refresh',
	'No Records': 'No Records',
	'eventLogs': 'Event Logs',
	'eventCount': 'Records',
	'eventTotal': 'Amount Summary',
	'eventAll': 'All',
	'eventInviteFeature': 'Invite',
	'eventRewardFeature': 'Rewards',
	'eventBonusFeature': 'Mining',
	'eventLockFeature': 'Lock',
	'eventLock': 'Lock',
	'eventRelease': 'Release',
	'eventClaim': 'Claim',
	'eventBonus': 'Bonus',
	'eventInvite': 'Invite',
	'eventTransfer': 'Transfer',
	'eventOcLocked': 'OC Locked',
	'eventOcStaticRelease': 'Static Release',
	'eventOcDynamicRelease': 'Dynamic Release',
	'eventOcClaimed': 'Lock Claim',
	'eventBonusTriggered': 'Bonus Distributed',
	'eventBonusReceived': 'Bonus Received',
	'eventInviteRequested': 'Invite Requested',
	'eventDirectReward': 'Direct Reward',
	'eventLiquidityReward': 'Liquidity Reward',
	'eventSlowQueryProgress': 'Query is slow, checked block {0}/{1}',
	'eventTenLevelBonus': 'Ten-Level Mining',
	'eventTenLevelBonusReceived': 'Ten-Level Mining Received',
	'eventReferralConfirmed': 'Referral Confirmed',
	'eventEffectiveInvite': 'Effective Invite',
	'eventEffectiveLp': 'Effective Account',
	'eventTransferIn': 'Transfer In',
	'Please Input Address': 'Please input valid address',
	'Lp Bonus Balance': 'Bonus Contract OC Balance',
	'Lp Bonus Distributed': 'Distributed Bonus',
	'addrBonus': 'Bonus Contract Address',
	'fund5': 'Foundation 5%',
	'ecoBurn5': 'Ecosystem Burn 5%',
	'genesis5': 'Genesis Team 5%',
	'tech3': 'Technical Service 3%',
	'market10': 'Market Value Management 10%',
	'coFound30': 'Co-founder Team 30%',
	'lpDepth10': 'My Dynamic Mining: {0} OC',
	'themeNeon': 'Neon Blue',
	'themeIce': 'Ice Circuit',
	'themeViolet': 'Violet Gold',
	'themeAurora': 'Aurora Mint',
	'themeEmber': 'Ember Night',
	'themeMono': 'Deep Mono',
	'delLpTimeScale': 'Remove Lp In Two Month 3 Scale',
}
